
import Vue from 'vue'
import { VAlert, VDivider } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcAlert',
  components: { VAlert, VDivider },
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: undefined,
    },
    message: {
      type: String,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alertColor() {
      if (this.type) return this.type
      return this.color
    },
  },
})
